import { Col, Container, FormLabel, Row } from 'react-bootstrap';
import Radio from '../Radio/Radio';

export type radioWithImageVariant = 'default' | 'transperant';

export type cardInfo = {
  imageRef: string;
  cardTitle: string;
  id: string;
  cardSubtitle?: string;
};

export type customRadioWithImageProps = React.PropsWithChildren<{
  cardData: cardInfo;
  selected?: boolean;
  variant?: radioWithImageVariant;
  className?: string;
  isBankDetailsCard?: boolean;
  chip?: React.ReactNode;
}>;

const RadioWithImage = ({
  cardData,
  selected,
  variant = 'default',
  isBankDetailsCard,
  chip,
  className,
}: customRadioWithImageProps) => {
  const { id, imageRef, cardTitle, cardSubtitle } = cardData;

  return (
    <Container
      className={`${className} mx-0 radio-with-image px-0 ${
        selected ? 'inactive' : ''
      } ${variant}`}
    >
      <FormLabel className={'w-100'}>
        <Row className={'mx-0 pb-7'}>
          <Col className={'px-0 col-12 priority-index'}>
            <Radio value={id} className={'ps-5 pt-6'} />
          </Col>
          <Col className={'d-flex flex-column align-items-center px-0'}>
            <img
              className={`radio-card-img ${
                isBankDetailsCard ? 'bank-card' : ''
              }`}
              src={`${process.env.PUBLIC_URL}/${imageRef}`}
              alt={imageRef}
            />
            <span
              className={`title ${
                isBankDetailsCard ? 'bank-card' : ''
              } text-center text-blue text-fs-base`}
            >
              {cardTitle}
            </span>
            {cardSubtitle && (
              <span
                className={`subtitle ${
                  isBankDetailsCard ? 'bank-card' : ''
                } text-center text-blue text-sub1 fw-light`}
              >
                {cardSubtitle}
              </span>
            )}
            {chip}
          </Col>
        </Row>
      </FormLabel>
    </Container>
  );
};

export default RadioWithImage;
